// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#df326f',
    },
    secondary: {
      main: '#ff4081',
    },
    background: {
      default: '#f4f4f4',
    },
  },
  typography: {
    fontFamily: 'Comfortaa, sans-serif',
    h5: {
      fontWeight: 400,
    },
  },
});

export default theme;
